import type { TransitionableStateModelType } from "@/entities/state";

import { REFERENTIAl_STATES_ENDPOINTS } from "./referential-states.enum";

export const getReferentialStateEndpointFromType = (
  type: TransitionableStateModelType
) => {
  const key = type.toUpperCase() as keyof typeof REFERENTIAl_STATES_ENDPOINTS;
  return REFERENTIAl_STATES_ENDPOINTS[key];
};
